// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'

import {fetchDevices} from '../../../../../../actions/deviceManagement'
import Table from '../../../../../Table'
import {renderFormField, renderFormSelectField} from '../../../../../../utils/formFields'

import AddIcon from '@material-ui/icons/Add'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import SearchIcon from '@material-ui/icons/Search'
// import CloseIcon from '@material-ui/icons/Close'
// import CheckIcon from '@material-ui/icons/Check'

import './index.css'

// const statusIcons = {
//   'Activated': <CheckIcon className='inner-table-icon green'/>,
//   'Deactivated': <CloseIcon className='inner-table-icon red'/>
// }

const deviceTypes = [
  {
    value: 'SetTopBox',
    name: 'Set Top Box'
  },
  {
    value: 'InternetTV',
    name: 'Internet TV'
  },
]

const status = [
  {
    value: 'Activated',
    name: 'Activated'
  },
  {
    value: 'Deactivated',
    name: 'Deactivated'
  },
]

const domains = [
  {
    value: '987654321',
    name: '987654321'
  },
  {
    value: '123465789',
    name: '123465789'
  },
]

// const MAX_LIST_DISPLAY = 11

export class DevicesTable extends Component {
  constructor (props) {
    super(props)
    this.state = {filters: null}
  }

  componentDidMount () {
    this.props.fetchDevices()
  }

  applyFilter (list, filters) {
    let filteredDevices = list
    if (list) {
      if (!filters)
        filteredDevices = list
      else if (filters.deviceId)
        filteredDevices = list.filter(device => device.deviceId.includes(filters.deviceId))
      else if (filters.networkDeviceId)
        filteredDevices = list.filter(device => device.verimatrixClientId.includes(filters.networkDeviceId))
    }
    return filteredDevices
  }

  tableHeaders () {
    return (
      <>
        <div className='th col-2'>
          Device ID
          <div className='row field-with-icon'>
            {renderFormField('deviceId', 'text', 'Enter full or partial ID', 'col-9')}
            <SearchIcon className='col-2'/>
          </div>
        </div>
        <div className='th col-2 align-bottom'>
          Device Type
        </div>
        <div className='th col-2'>
          Network Device ID
          <div className='row field-with-icon'>
            {renderFormField('networkDeviceId', 'text', 'Enter full or partial ID', 'col-9')}
            <SearchIcon className='col-2'/>
          </div>
        </div>
        <div className='th col-2 align-bottom'>
          Status
        </div>
        <div className='th col-2'>
          Domain ID
          <div className='row field-with-icon'>
            {renderFormField('domainId', 'text', 'Enter full or partial ID', 'col-9')}
            <SearchIcon className='col-2'/>
          </div>
        </div>
        <div className='th col-2 align-bottom align-right'>
          <button className='btn btn-search' type='submit'>Search</button>
        </div>
      </>
    )
  }

  handleHeaderSubmit = (e) => {
    e.preventDefault()
    this.setState({filters: this.props.devicesFormFilter.values})
  }

  addFormFields () {
    return (
      <>
        <div className='th col-1 user-icon'></div>
        <div className='td col-2'>
          {renderFormField('deviceId', 'text', 'Customer identifier', 'col-6')}
        </div>
        <div className='td col-2'>
          {renderFormSelectField('deviceTypes', deviceTypes, 'value', 'name', 'col-6')}
        </div>
        <div className='td col-2'>
          {renderFormField('networkDeviceId', 'text', 'Network Device ID', 'col-6')}
        </div>
        <div className='td col-2'>
          {renderFormSelectField('status', status, 'value', 'name', 'col-6')}
        </div>
        <div className='td col-2'>
          {renderFormSelectField('domains', domains, 'value', 'name', 'col-6')}
        </div>
      </>
    )
  }

  updateFormFields = (item) => {
    return (
      <>
        <div className='td col'>
          {renderFormField('deviceId', 'text', 'Customer identifier', 'col-6', item.deviceId)}
        </div>
        <div className='td col'>
          {renderFormSelectField('deviceType', deviceTypes, 'value', 'name', 'col-6')}
        </div>
        <div className='td col'>
          {renderFormField('networkDeviceId', 'text', 'Network Device ID', 'col-6', item.networkDeviceId)}
        </div>
        <div className='td col-2'>
          Coming soon
          {/* {renderFormSelectField('status', status, 'value', 'name', 'col-6')} */}
        </div>
        <div className='td col-2'>
          Coming soon
          {/* {renderFormSelectField('domains', domains, 'value', 'name', 'col-6')} */}
        </div>
      </>
    )
  }

  infoFields = (item) => {
    return (
      <>
        <div className='td col-2'>
          <span>{item.deviceId}</span>
        </div>
        <div className='td col-2'>
          <span>{item.deviceType}</span>
        </div>
        <div className='td col-2'>
          <span>{item.verimatrixClientId}</span>
        </div>
        <div className='td col-2'>
          <span>Coming soon</span>
        </div>
        <div className='td col-2'>
          <span>Coming soon</span>
        </div>
      </>
    )
  }

  floatingMenuButtons () {
    return (
      <div className='row floating-menu-buttons'>
        <div className='col-md-6'>
          <button className='btn btn-magenta'><DeleteOutlineIcon/> Remove </button>
        </div>
        <div className='col-md-6'>
          <button className='btn btn-purple pull-right'><AddIcon/> Create Domain </button>
        </div>
      </div>
    )
  }

  validate (values) {
    let ret = {}
    if (!values.deviceId || !values.deviceId.trim()) {
      ret = {...ret, username: 'Device ID cannot be blank'}
    }
    if (!values.networkDeviceId || !values.networkDeviceId.trim()) {
      ret = {...ret, firstName: 'Network device ID cannot be blank'}
    }
    if (!values.domain || !values.domain.trim()) {
      ret = {...ret, lastName: 'Domain cannot be blank'}
    }
    return ret
  }

  render () {
    let items = this.props.deviceManagement ? this.props.deviceManagement.devices : null

    items = this.applyFilter(this.props.deviceManagement.devices, this.state.filters)

    return (
      <div className='device-table'>
        <Table
          tableHeaders={this.tableHeaders()}
          items={items}
          validateAdd={this.validate}
          onAddSubmit={() => {return null}}
          addItemText={'Add a new device'}
          validateUpdate={this.validate}
          onUpdateSubmit={() => {return null}}
          updateFields={this.updateFormFields}
          infoFields={this.infoFields}
          showItemsCount={true}
          handleHeaderSubmit={this.handleHeaderSubmit}
        />
      </div>
    )
  }
}

function mapStateToProps ({session, deviceManagement, form}) {
  return {
    session: session,
    deviceManagement: deviceManagement,
    devicesFormFilter: form.tableHeaderFilter
  }
}

export default connect(mapStateToProps, {fetchDevices})(DevicesTable)
